<template>
  <div class="absolute inset-0">
    <div id="ruler-right"></div>
    <div id="size-right">{{ verticalSize }}</div>

    <div id="ruler-bottom"></div>
    <div id="size-bottom">{{ horizontalSize }}</div>

    <!--    <div v-if="rulers && $root.showMoveHint" id="move-hint" class="hint">-->
    <!--      Wist je dat je de kaart kan bewegen?-->
    <!--    </div>-->

  </div>
</template>

<script>

export default {
  name: "RulersLayer",

  computed: {
    verticalSize() {
      if (this.$root.print.orientation === 'horizontal')
        return (this.$root.currentSize.width / 10) + ' cm';

      return (this.$root.currentSize.height / 10) + ' cm';
    },
    horizontalSize() {
      if (this.$root.print.orientation === 'horizontal')
        return (this.$root.currentSize.height / 10) + ' cm';

      return (this.$root.currentSize.width / 10) + ' cm';
    },
  },

}
</script>

<style lang="scss" scoped>
$padding: 100;

$paddingPx: $padding * 1px;
$rulerInset: ($padding - 30) * 1px;

$sizeLabelRight: -50px;
$sizeLabelBottom: -70px;

#ruler-right {
  width: 2px;
  position: absolute;
  background-color: rgb(204, 204, 204);
  right: -25px;
  bottom: 0;
  top: 0;

  &::before {
    content: " ";
    background-color: rgb(204, 204, 204);
    width: 15px;
    position: absolute;
    bottom: 0;
    height: 2px;
    left: -6.5px;
  }

  &::after {
    content: " ";
    background-color: rgb(204, 204, 204);
    width: 15px;
    position: absolute;
    top: 0;
    height: 2px;
    left: -6.5px;
  }
}

#size-right {
  height: 3px;
  width: 3px;
  position: absolute;
  font-size: 24px;
  right: $sizeLabelRight;
  transform: rotate(-90deg);
  top: 50%;
  display: flex;
  -webkit-box-align: center;
  align-items: center;
  white-space: nowrap;
  color: rgb(204, 204, 204);
}

#ruler-bottom {
  position: absolute;
  background-color: rgb(204, 204, 204);
  height: 2px;
  bottom: -27px;
  left: 0;
  right: 0;

  &::before {
    content: " ";
    background-color: rgb(204, 204, 204);
    height: 15px;
    position: absolute;
    bottom: 0;
    width: 2px;
    top: -6.5px;
    right: 0;
  }

  &::after {
    content: " ";
    background-color: rgb(204, 204, 204);
    height: 15px;
    position: absolute;
    width: 2px;
    top: -6.5px;
    left: 0px;
  }
}

#size-bottom {
  position: absolute;
  color: rgb(204, 204, 204);
  font-size: 24px;
  text-align: center;
  left: 0;
  right: 0;
  bottom: $sizeLabelBottom;
}

</style>